import { InvestmentDataConfiguration } from '@wdx/shared/swagger-gen';
import { Observable } from 'rxjs';

export abstract class IGetPortfolioConfig {
    abstract get(): Observable<InvestmentDataConfiguration>;
}
